import React, { useMemo, } from 'react'
import { GraniteDataGrid } from '@tecuity/granite-ui/GraniteDataGrid';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { SET_SELECTED_REPORTS } from '../../Reconcile/ReconcileReducer';


const SelectReports = () => {
  const dispatch = useDispatch();
  const { batchNums, batchReports, selectedReports } = useSelector(state => state.reconcile, shallowEqual);

  const displayBatchNums = useMemo(() => {
    let val = "";
    batchNums.forEach((num, index) => {
      if (index === 0) val += num;
      else val += `, ${num}`
    })
    return val
  }, [batchNums])

  const selectReportsColumns = [
    { "field": "Display_Name", "flex": 1, "minWidth": 180, "headerName": "Report", "disableColumnMenu": true },
  ]

  const batchReportRows = useMemo(() => {
    return batchReports.map((report) => {
      return { ...report, id: report.ID }
    });
  }, [batchReports])

  return (
    <React.Fragment>
      <p className="reconcileLabel">{`Batch #: ${displayBatchNums}`}</p>
      <div className='accounting-table'>
        <GraniteDataGrid
          columns={selectReportsColumns}
          rows={batchReportRows}
          pagination={undefined}
          rowsPerPageOptions={[25, 50, 100]}
          selectionModel={selectedReports}
          onSelectionModelChange={(ids) => {
            dispatch({ type: SET_SELECTED_REPORTS, selectedReports: ids })
          }}
        />
      </div>
    </React.Fragment>
  )
}

export default SelectReports 